import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatLatency(ms) {
  if (ms < 1000) return `${Math.round(ms)}ms`;
  return `${(ms / 1000).toFixed(2)}s`;
}

export function formatCost(cost) {
  if (cost < 0.01) return `$${cost.toFixed(4)}`;
  return `$${cost.toFixed(2)}`;
}

export function formatNumber(num) {
  if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
  if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
  return num.toString();
}

export function getTierColor(tier) {
  const colors = {
    tier1_local_fast: '#10B981',
    tier2_local_smart: '#F59E0B',
    tier3_cloud: '#8B5CF6',
  };
  return colors[tier] || '#6B7280';
}

export function getTierName(tier) {
  const names = {
    tier1_local_fast: 'Local Fast',
    tier2_local_smart: 'Local Smart',
    tier3_cloud: 'Cloud Frontier',
  };
  return names[tier] || tier;
}

export function getTierIcon(tier) {
  const icons = {
    tier1_local_fast: 'Cpu',
    tier2_local_smart: 'Zap',
    tier3_cloud: 'Cloud',
  };
  return icons[tier] || 'Circle';
}

export function generateSessionId() {
  return `session-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}

export function timeAgo(timestamp) {
  const now = new Date();
  const date = new Date(timestamp);
  const seconds = Math.floor((now - date) / 1000);
  
  if (seconds < 60) return 'just now';
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  return `${Math.floor(seconds / 86400)}d ago`;
}
